import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './footer';
const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

const StrategyUserDetails = () => {
  const { strategyCode } = useParams();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterExpiringSoon, setFilterExpiringSoon] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(`${BASE_URL}/strategies/getUsersByStrategyCode/${strategyCode}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        const data = await res.json();
        setUsers(data.data || []);
      } catch (err) {
        console.error('Error fetching strategy users:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [strategyCode]);

  useEffect(() => {
    let result = [...users];

    if (searchTerm) {
      result = result.filter(user =>
        user.userid.toString().includes(searchTerm) ||
        user.strategycode.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filterExpiringSoon) {
      const today = new Date();
      const nextMonth = new Date();
      nextMonth.setMonth(today.getMonth() + 1);

      result = result.filter(user => {
        const expiry = new Date(user.subscription_expiry_date);
        return expiry >= today && expiry <= nextMonth;
      });
    }

    setFilteredUsers(result);
  }, [users, searchTerm, filterExpiringSoon]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxButtons = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    const endPage = Math.min(totalPages, startPage + maxButtons - 1);
  
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className={`page-item ${currentPage === i ? 'active' : ''}`} key={i}>
          <button className="page-link" onClick={() => paginate(i)}>
            {i}
          </button>
        </li>
      );
    }
  
    if (startPage > 1) {
      buttons.unshift(
        <li className="page-item" key="start-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }
    if (endPage < totalPages) {
      buttons.push(
        <li className="page-item" key="end-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }
    return buttons;
  };
  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between"  style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary" onClick={() => navigate(-1)}>Back</button>
            <h4 className="fw-bold">Users Subscribed to Strategy</h4>
            <div></div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search by User ID or Strategy Code"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '300px' }}
            />

            <div className="form-check ms-3">
                <input
                className="form-check-input"
                type="checkbox"
                id="expiringSoon"
                checked={filterExpiringSoon}
                onChange={() => setFilterExpiringSoon(!filterExpiringSoon)}
                />
                <label className="form-check-label" htmlFor="expiringSoon">
                Expiring in 1 Month
                </label>
            </div>
            </div>


          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User ID</th>
                    <th>Subscription Expiry</th>
                    <th>Status</th>
                    <th>Created On</th>
                    <th>Modified On</th>
                  </tr>
                </thead>
                <tbody>
                {currentUsers.length > 0 ? (
                    currentUsers.map((user) => (
                      <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>{user.userid}</td>
                        <td>{user.subscription_expiry_date}</td>
                        <td>{user.status === 1 ? 'Active' : 'Inactive'}</td>
                        <td>{new Date(user.createdon).toLocaleDateString()}</td>
                        <td>{new Date(user.modifiedon).toLocaleDateString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">No users found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        
        <nav className="d-flex justify-content-center mt-3">
          <ul className="pagination">
            <li className="page-item">
              <button className="page-link" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
            </li>
            {renderPaginationButtons()}
            <li className="page-item">
              <button className="page-link" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </li>
          </ul>
        </nav>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default StrategyUserDetails;
